import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { Button } from '@components/Button';
import { Spacer } from '@components/Spacer';
import { useIntegration } from '@account_module/hooks/useIntegrations';
import { useMegaphoneOnboardContext } from '@account_module/context/MegaphoneOnboardContext';
import loaderImage from '@assets/images/loader.png';
import { Loader } from '@components/Loader';

const LargeText = tw.p`text-[24px] font-bold leading-[140%]`;
const SmallText = tw.p`text-[20px] text-text-muted-2 font-semibold leading-[140%]`;
const SubmitButton = tw(Button.Primary)`w-[255px] px-6 bg-[#2A3FCB]`;

const LoadingSpinner = () => (
  <img tw='animate-spin mx-auto mb-8' width='73' height='73' src={loaderImage} alt='loader' />
);

export const SuccessScreen = () => {
  const { t } = useTranslation();
  const { integrationId } = useMegaphoneOnboardContext();
  const { updateIntegration, isUpdateLoading } = useIntegration(integrationId);

  return (
    <div tw='h-full w-full flex items-center justify-center'>
      <div tw='text-center'>
        <LoadingSpinner />
        <LargeText>{t('account_module.onboard_page.success_screen.message_1')}</LargeText>
        <LargeText>{t('account_module.onboard_page.success_screen.message_2')}</LargeText>
        <Spacer direction='vertical' size='md' />
        <SmallText>{t('account_module.onboard_page.success_screen.invite_team_member')}</SmallText>
        <Spacer direction='vertical' size='md' />

        <SubmitButton
          type='button'
          onClick={async () => {
            updateIntegration && (await updateIntegration({ progress_step: 4 }));
            window && window.location.reload();
          }}>
          {isUpdateLoading ? (
            <Loader size='sm' theme='dark' />
          ) : (
            t('account_module.onboard_page.success_screen.action.link')
          )}
        </SubmitButton>
      </div>
    </div>
  );
};
